import React from 'react';
import I18n from 'i18n-js';
import arrowIcon from 'images/icons/arrow.svg';
import { twMerge } from '@/utils';
import { TCITooltip } from '@/components/ui/Tooltip';
import playIcon from 'images/icons/present.svg';
import Icon from '@/components/ui/Icon';

interface GoToButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  iconType?: 'play' | 'arrow';
  label?: string;
  extraClassName?: string;
  useNewIcon?: boolean;
}

export const ACTION_BAR_BTN_SHADOW = '-1.5px 1.5px 5px rgba(0,0,0,0.15)';
export const CIRCLE_ICON_CLASS = twMerge(
  'tw-border-none tw-rounded-[50%] tw-text-2xl',
  'tw-flex tw-justify-center tw-items-center',
  'tw-cursor-pointer tw-mr-[10px] tw-h-11 tw-w-11',
);

const GoToButton = React.forwardRef<HTMLAnchorElement, GoToButtonProps>(
  ({ href, iconType, label, extraClassName, useNewIcon = false, ...rest }, ref) => {
    const icon = iconType === 'play' ? playIcon : arrowIcon;
    const showTooltip = iconType === 'play';
    const useNewPlayIcon = useNewIcon && iconType === 'play';

    const link = (
      <a
        ref={ref}
        aria-label={I18n.t('go_to', { name: label })}
        className={twMerge(
          CIRCLE_ICON_CLASS,
          'tw-bg-tci-purple tw-text-white hover:tw-text-white focus:tw-text-white',
          extraClassName,
        )}
        href={href}
        style={{ boxShadow: ACTION_BAR_BTN_SHADOW }}
        target={iconType === 'play' ? '_blank' : ''}
        {...rest}
      >
        {useNewPlayIcon && <Icon icon="Play" size={22} />}
        {!useNewPlayIcon && <img aria-hidden alt="" src={icon} />}
      </a>
    );

    if (!showTooltip) return link;

    return (
      <TCITooltip sideOffset={15}>
        <TCITooltip.Trigger asChild>
          {link}
        </TCITooltip.Trigger>
        <TCITooltip.Content>
          {I18n.t('present_slides_card')}
        </TCITooltip.Content>
      </TCITooltip>
    );
  },
);
GoToButton.displayName = 'GoToButton';

export default GoToButton;
